import { useCallback, useEffect, useRef } from 'react';
import UniversalSaveBar from 'customer-data-properties/savebar/UniversalSaveBar';
// @ts-expect-error no types
import UnsavedChanges from 'customer-data-properties/savebar/UnsavedChanges';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useInlineEdit } from 'framework-asset-preview-lib/internal/shared/providers/InlineEditProvider';
import AssetPreview from './AssetPreview';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const AUTO_SAVE_DELAY_MS = 1000;
export default function ConnectedAssetPreviewModal(props) {
  const {
    isDraft,
    onReset,
    onSave,
    onPartialSave,
    formState,
    isLoading,
    hasErrors
  } = useInlineEdit();
  const flushChanges = useCallback(() => {
    if (hasErrors || Object.keys(formState).length === 0) {
      return;
    }
    onPartialSave(formState);
  }, [onPartialSave, formState, hasErrors]);
  const flushChangesRef = useRef(flushChanges);
  useEffect(() => {
    flushChangesRef.current = flushChanges;
  }, [flushChanges]);
  useEffect(() => {
    if (!props.hasAutoSave) {
      return;
    }
    const id = setTimeout(() => {
      flushChangesRef.current();
    }, AUTO_SAVE_DELAY_MS);
    return () => {
      clearTimeout(id);
    };
  }, [props.hasAutoSave, hasErrors, formState]);
  if (props.hasAutoSave) {
    return /*#__PURE__*/_jsx(AssetPreview, Object.assign({}, props));
  }
  return /*#__PURE__*/_jsxs(UnsavedChanges, {
    changes: isDraft,
    errors: hasErrors,
    loading: isLoading,
    onCancel: onReset,
    onSave: onSave,
    children: [/*#__PURE__*/_jsx(UniversalSaveBar, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "frameworkAssetPreviewLib.saveBar.info",
        options: {
          count: Object.keys(formState).length
        }
      })
    }), /*#__PURE__*/_jsx(AssetPreview, Object.assign({}, props))]
  });
}